module.exports = __webpack_public_path__ + "img/quest_icon_0033_flight.ce89b466.png";